
 <!--category-->
<template>
    <!--<v-container fluid class="bg-surface">-->
    <!--Web View Tab screen-->
    <v-row dense class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
        <v-col cols="12">
            <div class="d-flex align-content-center justify-center text-center mt-4 mb-4">
                <v-sheet class="mx-auto bg-white" elevation="0" min-width="220">
                    <v-slide-group >
                        <v-slide-group-item v-for="category in categoryList" :key="category.id">
                            <v-sheet class="d-block align-content-center justify-center text-center bg-white mx-auto" width="125"
                                style="cursor: pointer">
                                <v-avatar color="white" size="70" @click="categoryPage(category.id)">
                                    <v-img cover :src="category.image"></v-img>
                                </v-avatar>
                                <p class="maincategory-name text-center">{{ category.name }}</p>
                            </v-sheet>
                        </v-slide-group-item>
                    </v-slide-group>
                </v-sheet>
            </div>
        </v-col>
    </v-row>
    <!--Web View Tab screen End-->

    <!--Mobile View Tab screen-->
    <v-row dense class="d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mt-4">
        <v-col cols="12">
            <div class="d-flex align-content-center justify-center text-center mt-4 mb-4">
                <v-sheet class="mx-auto bg-secondary" elevation="0" min-width="220">
                    <v-slide-group show-arrows>
                        <v-slide-group-item v-for="category in categoryList" :key="category.id">
                            <v-sheet class="d-block align-content-center justify-center text-center bg-secondary mx-auto" width="110"
                                style="cursor: pointer">
                                <v-avatar color="white" size="50" @click="categoryPage(category.id)">
                                    <v-img cover :src="category.image"></v-img>
                                </v-avatar>
                                <p class="maincategory-name-mobile text-center">{{ category.name }}</p>
                            </v-sheet>
                        </v-slide-group-item>
                    </v-slide-group>
                </v-sheet>
            </div>
        </v-col>
    </v-row>
    <!--Mobile View Tab screen End-->
    
    <!--</v-container>-->
</template>
  <!--category-->

<style>
.maincategory-name {
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;   
    text-align: center;
    letter-spacing: .72px;
    text-transform: capitalize;
    min-width: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: #434B4D;
}
.maincategory-name-mobile {
    font-weight: 400;
    font-size: 11px;
    /* line-height: 22px;    */
    text-align: center;
    /* letter-spacing: .72px; */
    text-transform: capitalize;
    /* min-width: 110px; */
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: #434B4D;
}
</style>
<script>

import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    name: 'AppFooter',
    data: () => ({
    }),
    created() {
        this.getCategory();
    },
    computed: {
        ...mapGetters([
            "categoryList",
        ]),
    },
    methods: {
        ...mapActions([
            "getCategory",
        ]),
        categoryPage(id) {
            //console.log(id);
            router.push("/category/" + id + "/all");
        },
    },
}
</script>